import CHROME_ICON from '../../pngs/Chrome.png'

export const ChromeIcon = (): JSX.Element => {
  return <img src={CHROME_ICON} width={24} height={24} alt='Chrome Logo' />
}
